export const gdpr = {
  routes: [
    {
      path: "/gdpr/entities",
      component: () => import("../organization-entities-view"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/entities",
      component: () => import("../organization-entities-view"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/entities",
      component: () => import("../organization-entities-view"),
    },
  ],
};

export const bgys = {
  routes: [
    {
      path: "/bgys/entities",
      component: () => import("../organization-entities-view"),
    },
  ],
};
